import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router';

import { IframeMessageType } from '../types';
import { getTabNameFromPath } from '../utils/formatTabName';

export function useGZTabTracking(): void {
  const { pathname } = useLocation();
  const previousPathname = useRef<string | null>(null);

  useEffect(() => {
    const hasParentIFrame = typeof window !== 'undefined' && window.parentIFrame;
    const isNewPath = previousPathname.current !== pathname;

    if (!hasParentIFrame || !isNewPath) return;

    const tabName = getTabNameFromPath(pathname);
    if (!tabName) return;

    window.parentIFrame.sendMessage({
      type: IframeMessageType.SPA_TAB_CHANGE,
      data: { tabName, pathname },
    });

    previousPathname.current = pathname;
  }, [pathname]);
}
